<template>
  <el-dialog
    :title="pathDialog.type === 'edit' ? '编辑学习路径' : '新增学习路径'"
    :visible.sync="pathDialog.visible"
    width="600px"
    @close="pathDialogClose"
  >
    <el-form :model="pathDialog.form" label-width="120px" :rules="pathRules" ref="pathFormRef">
      <el-form-item label="学习路径名称" prop="name">
        <el-input v-model="pathDialog.form.name" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="pathDialogClose">取消</el-button>
      <el-button type="primary" @click="pathSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { studyPathSave } from '@/request/api/knowledge_graph.js'

export default {
  name: 'KgPathDialog',
  inject: ['pathDialog', 'getHypergraphstudypathData', 'courseId'],
  data() {
    return {
      pathRules: {
        name: [{ required: true, message: '请输入学习路径名称', trigger: 'blur' }],
      },
    }
  },
  methods: {
    pathDialogClose() {
      this.pathDialog.visible = false
      this.pathDialog.type = 'add'
      this.pathDialog.form = { name: '' }
    },
    pathSubmit() {
      this.$refs.pathFormRef.validate(valid => {
        if (valid) {
          var form = this.pathDialog.form
          var params = {
            id: form.id,
            name: form.name,
            courseId: this.courseId.value,
          }
          studyPathSave(params).then(res => {
            if (res.code != 0) return this.$message.error(res.msg || '操作失败')
            this.$message.success('操作成功')
            this.pathDialogClose()
            this.getHypergraphstudypathData()
          })
        }
      })
    },
  },
}
</script>
